import React from 'react';

import { IIssueSpecDetail, IIssueStackItem } from 'typings';

import { PillGroupStyled, Subhead } from './styles';

interface IQuestionPillGroupProps {
  details: IIssueSpecDetail;
  index: number;
  issueStackItem: IIssueStackItem;
  onRadioChange: (
    event: React.FormEvent<HTMLInputElement>,
    value?: string | Array<string>,
  ) => void;
}

export const QuestionPillGroup = ({
  details,
  index,
  issueStackItem,
  onRadioChange,
}: IQuestionPillGroupProps) => {
  const { optionAnswers } = issueStackItem;
  const { label: subhead, options } = details;

  if (!options) {
    return null;
  }

  const radioOptions = options.map(
    ({ label, nextValue, serviceCodeId, toIssueId }, optionIndex) => {
      const value = serviceCodeId || nextValue || toIssueId || '';

      return {
        key: value,
        label,
        value: String(optionIndex),
      };
    },
  );

  const optionAnswerIndex = optionAnswers[index]?.index;

  return (
    <>
      <Subhead>{subhead}</Subhead>
      <PillGroupStyled
        onChange={onRadioChange}
        options={radioOptions}
        size="small"
        value={String(optionAnswerIndex)}
      />
    </>
  );
};
